/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SessionsRouteImport } from './routes/sessions'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SessionsIndexRouteImport } from './routes/sessions.index'
import { Route as SessionsSessionIdRouteImport } from './routes/sessions.$sessionId'

const SessionsRoute = SessionsRouteImport.update({
  id: '/sessions',
  path: '/sessions',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SessionsIndexRoute = SessionsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SessionsRoute,
} as any)
const SessionsSessionIdRoute = SessionsSessionIdRouteImport.update({
  id: '/$sessionId',
  path: '/$sessionId',
  getParentRoute: () => SessionsRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/login': typeof LoginRoute
  '/sessions': typeof SessionsRouteWithChildren
  '/sessions/$sessionId': typeof SessionsSessionIdRoute
  '/sessions/': typeof SessionsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/login': typeof LoginRoute
  '/sessions/$sessionId': typeof SessionsSessionIdRoute
  '/sessions': typeof SessionsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/login': typeof LoginRoute
  '/sessions': typeof SessionsRouteWithChildren
  '/sessions/$sessionId': typeof SessionsSessionIdRoute
  '/sessions/': typeof SessionsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/login'
    | '/sessions'
    | '/sessions/$sessionId'
    | '/sessions/'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/admin' | '/login' | '/sessions/$sessionId' | '/sessions'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/login'
    | '/sessions'
    | '/sessions/$sessionId'
    | '/sessions/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRoute: typeof AdminRoute
  LoginRoute: typeof LoginRoute
  SessionsRoute: typeof SessionsRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/sessions': {
      id: '/sessions'
      path: '/sessions'
      fullPath: '/sessions'
      preLoaderRoute: typeof SessionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sessions/': {
      id: '/sessions/'
      path: '/'
      fullPath: '/sessions/'
      preLoaderRoute: typeof SessionsIndexRouteImport
      parentRoute: typeof SessionsRoute
    }
    '/sessions/$sessionId': {
      id: '/sessions/$sessionId'
      path: '/$sessionId'
      fullPath: '/sessions/$sessionId'
      preLoaderRoute: typeof SessionsSessionIdRouteImport
      parentRoute: typeof SessionsRoute
    }
  }
}

interface SessionsRouteChildren {
  SessionsSessionIdRoute: typeof SessionsSessionIdRoute
  SessionsIndexRoute: typeof SessionsIndexRoute
}

const SessionsRouteChildren: SessionsRouteChildren = {
  SessionsSessionIdRoute: SessionsSessionIdRoute,
  SessionsIndexRoute: SessionsIndexRoute,
}

const SessionsRouteWithChildren = SessionsRoute._addFileChildren(
  SessionsRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRoute: AdminRoute,
  LoginRoute: LoginRoute,
  SessionsRoute: SessionsRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
